var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZatca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 44,
    viewBox: "0 0 35 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.121 0.332162L16.9033 0L0.046875 12.0211L0.264623 12.357L17.121 0.332162Z",
    fill: "url(#paint0_linear_514_1686)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7831 0.537558L13.5653 0.20166L0.0566406 9.8342L0.274345 10.1664L13.7831 0.537558Z",
    fill: "url(#paint1_linear_514_1686)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68617 1.25775L9.46847 0.921875L0.0712891 7.6471L0.288993 7.97926L9.68617 1.25775Z",
    fill: "url(#paint2_linear_514_1686)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.20064 2.97813L3.97936 2.646L0.0820312 5.46372L0.303308 5.79588L4.20064 2.97813Z",
    fill: "url(#paint3_linear_514_1686)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5787 15.5292V15.5217L22.8448 17.4736L22.8484 17.4773L8.78651 27.5018L9.07915 27.9459L7.16974 29.3417L7.31604 29.5656L3.25098 32.5326L3.47225 32.8648L7.95848 29.588L9.43962 28.502H9.4432L23.7192 18.3208L23.4265 17.8729L25.9391 16.0815L25.7964 15.8613L34.9723 9.31898L34.7546 8.98682L25.5787 15.5292Z",
    fill: "url(#paint4_linear_514_1686)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.357 17.1453L26.3534 17.1416L23.4304 19.2279L23.434 19.2316L9.82534 28.935L10.1144 29.3754L8.06941 30.8683L8.21214 31.081L4.22559 34.0032L4.44686 34.3316L8.43342 31.4131L8.43699 31.4206L10.4785 29.9315V29.9352L24.1299 20.2019L23.8373 19.7541L26.7175 17.7014L26.5747 17.4812L34.9583 11.5024L34.7406 11.1665L26.357 17.1453Z",
    fill: "url(#paint5_linear_514_1686)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1033 18.7912V18.7837L24.6799 20.5117L10.7929 30.4167L11.082 30.8608L9.20828 32.2267L9.35105 32.4432L5.3252 35.3916L5.54647 35.7237L9.57232 32.7754L9.5759 32.7791L11.4461 31.4169L25.3402 21.5119L25.0475 21.064L27.4638 19.3435L27.321 19.1233L34.948 13.6857L34.7303 13.3535L27.1033 18.7912Z",
    fill: "url(#paint6_linear_514_1686)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2447 20.1495V20.1458L25.8428 21.8551L25.8464 21.8588L11.8023 31.8273L12.0986 32.2826L9.70377 34.0329L9.85011 34.2568L6.52734 36.6827L6.74862 37.0149L10.546 34.2419V34.2382L13.0979 32.3721L26.6244 22.7732L26.3318 22.3253L28.6052 20.7019L28.4624 20.4817L34.9331 15.8688L34.7154 15.5366L28.2447 20.1495Z",
    fill: "url(#paint7_linear_514_1686)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6551 21.3104V21.3067L27.0284 23.1802V23.1839L14.8438 31.8722L15.1328 32.3126L12.2527 34.4175L12.399 34.6377L7.89844 37.9257L8.11971 38.2579L13.02 34.6788L15.4933 32.8687L15.4969 32.8724L27.7564 24.1318L27.4638 23.684L30.0156 21.8627L29.8728 21.6463L34.923 18.0448L34.7053 17.7126L29.6551 21.3104Z",
    fill: "url(#paint8_linear_514_1686)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7778 21.4186L32.7064 21.3066L29.6263 23.5048L17.8344 31.9132L18.127 32.3611L14.947 34.6824L15.0969 34.9064L9.51855 38.9818L9.73983 39.3103L15.7108 34.9512V34.9474L18.7802 32.7044L30.2795 24.505L29.9904 24.0609L33.0704 21.8627L32.8884 21.5865L32.9991 21.7507L34.9121 20.3362L34.6908 20.0078L32.7778 21.4186Z",
    fill: "url(#paint9_linear_514_1686)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8316 23.3966L32.828 23.3929L31.0935 24.6319L24.1589 29.5732L24.4515 30.0248L21.5142 32.1708L21.6641 32.3909L11.082 40.1239L11.3033 40.456L22.303 32.4171L24.8727 30.5361V30.5324L31.7466 25.6321L31.4575 25.188L33.192 23.9489L33.0493 23.7288L34.8659 22.4337L34.6482 22.1016L32.8316 23.3966Z",
    fill: "url(#paint10_linear_514_1686)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1776 25.4044L33.142 25.3484L31.5037 26.5129V26.5091L25.9968 30.4353L26.2894 30.8831L23.7269 32.7567L23.8732 32.9806L12.7236 41.1278L12.9449 41.4599L24.6691 32.8948L24.6656 32.891L26.9176 31.2489L32.1569 27.5131L31.8678 27.069L33.5024 25.9045L33.324 25.6246L34.5696 24.7364L34.4268 24.5125L33.1776 25.4044Z",
    fill: "url(#paint11_linear_514_1686)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1.59934 14.5737L3.16256 13.428L9.09068 9.20324L8.80157 8.75914L11.4034 6.90427L11.2606 6.68407L20.0332 0.432799L19.8155 0.0969238L11.0429 6.35193V6.3482L8.43752 8.20304L2.16322 12.6741L2.45586 13.1257L0.967614 14.2117L1.11748 14.4357L0.0253906 15.2306L0.246667 15.5628L1.59934 14.5737Z",
    fill: "url(#paint12_linear_514_1686)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.58079 16.0442L4.12972 14.9134L11.4533 9.68845L11.1642 9.24806L13.1879 7.80372L13.0522 7.59846L22.5958 0.72767L22.3781 0.395508L12.8345 7.26258L12.8238 7.24764L10.8038 8.68825H10.8002L3.00905 14.2453L3.30169 14.6932L1.96331 15.6747L2.10965 15.8949L0.0146484 17.4288L0.235925 17.761L2.58079 16.0442Z",
    fill: "url(#paint13_linear_514_1686)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93018 17.9776L4.98236 16.4773L12.9591 10.7896L12.6629 10.3343L14.8043 8.80413L14.6722 8.59513L24.9652 1.1869L24.7475 0.854736L14.4545 8.26297L14.4438 8.24803L12.206 9.84164L12.2132 9.85285L3.85455 15.813L4.14723 16.2646L2.34129 17.5857L2.4912 17.806L0 19.6272L0.22132 19.9556L2.93018 17.9776Z",
    fill: "url(#paint14_linear_514_1686)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75139 19.5674L5.98916 17.9327L14.4656 11.8867L14.1729 11.4426L16.4357 9.83034L16.2822 9.59522L27.3104 1.82125L27.0963 1.48535L15.9182 9.36754L15.9253 9.37501L13.8017 10.8902V10.894L4.70076 17.3841L4.99697 17.8357L2.91625 19.3546L3.06259 19.5786L0.0146484 21.8029L0.235925 22.1351L3.75139 19.5674Z",
    fill: "url(#paint15_linear_514_1686)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75392 21.0079L6.19938 19.9555L15.9678 12.9877L15.6786 12.5398L18.2055 10.741L18.0628 10.5208L29.1516 2.61617L28.9339 2.28027L17.845 10.1886L17.8415 10.1811L15.3004 11.9949V11.9987L5.54623 18.9516L5.83534 19.3957L3.96875 20.7616L4.11862 20.9856L0.196289 23.8444L0.413993 24.1765L4.75749 21.0117L4.75392 21.0079Z",
    fill: "url(#paint16_linear_514_1686)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72841 22.4933L7.37372 21.2878L17.474 14.0886L17.1813 13.6408L19.9795 11.6441L19.8367 11.4276L31.2254 3.30658L31.0077 2.9707L19.619 11.0918L19.6154 11.088L16.6496 13.2041H16.6531L6.38867 20.5228L6.68493 20.9706L4.92181 22.2582L5.07173 22.4784L0.539062 25.7887L0.760339 26.1209L5.72841 22.4933Z",
    fill: "url(#paint17_linear_514_1686)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00647 24.479L8.36915 22.7547L20.2896 14.3015L19.997 13.8499L22.6345 11.9689L22.4917 11.7487L33.0702 4.20619L32.8525 3.87402L22.274 11.4166L22.2704 11.4129L19.5508 13.3498L19.5544 13.3573L7.17354 22.1352L7.46975 22.5905L5.26056 24.2028L5.41043 24.423L1.03125 27.6214L1.25253 27.9535L6.00647 24.479Z",
    fill: "url(#paint18_linear_514_1686)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29882 26.4345L8.39025 24.9081L21.3351 15.6786L21.046 15.2345L23.6942 13.346L23.5514 13.1296L34.7438 5.14659L34.5261 4.81445L23.3337 12.7937L23.3302 12.7899L20.6819 14.6784V14.6747L7.44808 24.1131L7.74071 24.561L5.49937 26.1956L5.64928 26.4196L1.64844 29.3418L1.86971 29.674L6.30239 26.4345H6.29882Z",
    fill: "url(#paint19_linear_514_1686)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M6.713 28.3042L8.48321 27.0092V27.0129L22.3024 17.1601L22.0133 16.716L24.5402 14.9134L24.3974 14.697L34.9831 7.14693L34.7654 6.81104L24.1797 14.3611L24.1762 14.3574L21.6493 16.1599L7.8301 26.009L8.11916 26.4531L6.03488 27.9795L6.18836 28.2109L2.38379 30.9652L2.60507 31.2973L6.72014 28.3191L6.713 28.3042Z",
    fill: "url(#paint20_linear_514_1686)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3291 42.1092L14.5504 42.4414L33.6696 28.5206L33.4483 28.1885L14.3291 42.1092Z",
    fill: "url(#paint21_linear_514_1686)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9395 43.1878L16.1607 43.52L32.2534 31.7601L32.0321 31.428L15.9395 43.1878Z",
    fill: "url(#paint22_linear_514_1686)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6426 41.2321L21.8639 41.5643L28.9305 36.3991L28.7092 36.0669L21.6426 41.2321Z",
    fill: "url(#paint23_linear_514_1686)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_514_1686",
    x1: 24.0767,
    y1: -8.13627,
    x2: -11.2,
    y2: 21.6705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61B24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4562,
    stopColor: "#51B9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_514_1686",
    x1: 22.8764,
    y1: -9.55565,
    x2: -12.4004,
    y2: 20.2511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61B24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4562,
    stopColor: "#51B9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_514_1686",
    x1: 21.6325,
    y1: -11.0282,
    x2: -13.6441,
    y2: 18.7784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61B24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4562,
    stopColor: "#51B9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_514_1686",
    x1: 20.3229,
    y1: -12.5782,
    x2: -14.9538,
    y2: 17.2282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61B24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4562,
    stopColor: "#51B9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_514_1686",
    x1: 35.69,
    y1: 5.60927,
    x2: 0.413251,
    y2: 35.4159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61B24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4562,
    stopColor: "#51B9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_514_1686",
    x1: 36.7674,
    y1: 6.88418,
    x2: 1.49062,
    y2: 36.6908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61B24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4562,
    stopColor: "#51B9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_514_1686",
    x1: 37.8538,
    y1: 8.16956,
    x2: 2.57704,
    y2: 37.9762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61B24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4562,
    stopColor: "#51B9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_514_1686",
    x1: 38.9386,
    y1: 9.45397,
    x2: 3.66185,
    y2: 39.2606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61B24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4562,
    stopColor: "#51B9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_514_1686",
    x1: 40.0483,
    y1: 10.7668,
    x2: 4.77153,
    y2: 40.5735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61B24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4562,
    stopColor: "#51B9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_514_1686",
    x1: 41.1947,
    y1: 12.1238,
    x2: 5.91795,
    y2: 41.9305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61B24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4562,
    stopColor: "#51B9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_514_1686",
    x1: 42.3709,
    y1: 13.5156,
    x2: 7.09414,
    y2: 43.3223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61B24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4562,
    stopColor: "#51B9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_514_1686",
    x1: 43.5047,
    y1: 14.8575,
    x2: 8.22793,
    y2: 44.6643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61B24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4562,
    stopColor: "#51B9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_514_1686",
    x1: 25.3571,
    y1: -6.62082,
    x2: -9.91965,
    y2: 23.1858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61B24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4562,
    stopColor: "#51B9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_514_1686",
    x1: 26.5476,
    y1: -5.21194,
    x2: -8.72921,
    y2: 24.5947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61B24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4562,
    stopColor: "#51B9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_514_1686",
    x1: 27.7329,
    y1: -3.80845,
    x2: -7.54389,
    y2: 25.9983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61B24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4562,
    stopColor: "#51B9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_514_1686",
    x1: 28.9554,
    y1: -2.36207,
    x2: -6.3213,
    y2: 27.4446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61B24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4562,
    stopColor: "#51B9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_514_1686",
    x1: 30.0919,
    y1: -1.01663,
    x2: -5.18489,
    y2: 28.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61B24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4562,
    stopColor: "#51B9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_514_1686",
    x1: 31.2482,
    y1: 0.351666,
    x2: -4.02856,
    y2: 30.1584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61B24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4562,
    stopColor: "#51B9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_514_1686",
    x1: 32.4086,
    y1: 1.72564,
    x2: -2.86813,
    y2: 31.5323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61B24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4562,
    stopColor: "#51B9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_514_1686",
    x1: 33.5417,
    y1: 3.0669,
    x2: -1.73504,
    y2: 32.8736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61B24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4562,
    stopColor: "#51B9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_514_1686",
    x1: 34.6148,
    y1: 4.33673,
    x2: -0.661926,
    y2: 34.1434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61B24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4562,
    stopColor: "#51B9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_514_1686",
    x1: 44.66,
    y1: 16.2255,
    x2: 9.38322,
    y2: 46.0322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61B24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4562,
    stopColor: "#51B9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_514_1686",
    x1: 45.7284,
    y1: 17.4891,
    x2: 10.4517,
    y2: 47.2959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61B24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4562,
    stopColor: "#51B9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0293D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_514_1686",
    x1: 46.8862,
    y1: 18.8594,
    x2: 11.6094,
    y2: 48.6661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61B24D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4562,
    stopColor: "#51B9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0293D2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZatca);
export default __webpack_public_path__ + "static/media/ZATCA.d043b1faec75df9b799e4d3940b956db.svg";
export { ForwardRef as ReactComponent };